module.exports = __webpack_public_path__ + "img/landing-2-de-DE.cdcc828.png";